import { observer } from 'mobx-react-lite'
import { ScreenWithCobrandingHeader } from '../../ui/white-label-components/ScreenWithCobrandingHeader'
import Application from './Application'
import React from 'react'

export const InHouseCreditApplication = observer(() => {
  return (
    <ScreenWithCobrandingHeader>
      <Application />
    </ScreenWithCobrandingHeader>
  )
})
